import styled from 'styled-components';

export const TabContainer = styled.div<{ $isActive?: boolean; $isDisabled?: boolean }>`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  ${({ theme: { font } }) => font.t3};
  border-radius: 4px 4px 0px 0px;

  ${({ theme, $isActive, $isDisabled }) => {
    if ($isActive) {
      return `
      color: ${theme.color.s1};
      fill: ${theme.color.s1};
      border-bottom: 2px solid ${theme.color.s1}`;
    }
    if ($isDisabled) {
      return `
      color: ${theme.color.ui4};
      fill: ${theme.color.ui4};
      border-bottom: 2px solid transparent`;
    }
    return `
    color: ${theme.color.ui2};
    fill: ${theme.color.ui2};
    border-bottom: 2px solid transparent`;
  }};

  &:hover {
    color: ${({ theme, $isDisabled }) => ($isDisabled ? theme.color.ui4 : theme.color.s2)};
    fill: ${({ theme, $isDisabled }) => ($isDisabled ? theme.color.ui4 : theme.color.s2)};
    border-bottom: 2px solid
      ${({ theme, $isDisabled }) => ($isDisabled ? 'transpartent' : theme.color.s2)};

    & > .tab-count {
      border-bottom: none;
      color: ${({ theme, $isDisabled }) => ($isDisabled ? theme.color.ui4 : theme.color.s2)};
      background-color: ${({ theme, $isDisabled }) =>
        $isDisabled ? theme.color.ui4 : theme.color.s2};
    }
  }
`;

export const Text = styled.div`
  padding-top: 2px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconWrapper = styled.div`
  box-sizing: border-box;
  fill: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-bottom: none;
  & > * {
    width: 100%;
    height: 100%;
  }
  &:hover {
    border-bottom: none;
  }
`;

export const Count = styled.div<{ $isActive?: boolean; $isDisabled?: boolean }>`
  display: flex;
  width: 16px;
  height: 16px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px;

  background-color: ${({ theme }) => theme.color.ui2};

  ${({ theme, $isActive, $isDisabled }) => {
    if ($isActive) {
      return `background-color: ${theme.color.s1};`;
    }
    if ($isDisabled) {
      return `background-color: ${theme.color.ui4};`;
    }
    return `background-color: ${theme.color.ui2};`;
  }};
`;

export const CountNumber = styled.div`
  color: ${({ theme }) => theme.color.ui7};
  ${({ theme: { font } }) => font.t6};
`;
